import { Box, Flex } from '@modusign/design-system';
import { css } from 'emotion';
import { ReactNode } from 'react';

import Table from '@app/components/Table';
import useResponsiveValue from '@app/hooks/useResponsiveValue';

interface ResponsiveTableProps {
  dataList: Array<{
    title: string;
    value: ReactNode;
  }>;
  responsiveValues?: [boolean, boolean, boolean];
}

export default function ResponsiveTable({
  dataList,
  responsiveValues = [true, false, false],
}: ResponsiveTableProps) {
  const isMobileWidth = useResponsiveValue(responsiveValues);

  return (
    <>
      {isMobileWidth ? (
        dataList.map(({ title, value }, index) => (
          <Flex
            alignItems="center"
            flexDirection="column"
            justifyContent="flex-start"
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            mb={4}
            width="100%"
          >
            <TableTitle title={title} />
            <Box width="100%">{value}</Box>
          </Flex>
        ))
      ) : (
        <Table
          className="align-left"
          direction="vertical"
          headClassName={css`
            width: 150px;
          `}
          rowClassName={css`
            .Table__cell {
              padding: 0;
            }
          `}
          titles={dataList.map(({ title }, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <Box key={idx} maxWidth="126px" width="126px">
              {title}
            </Box>
          ))}
          values={[dataList.map(({ value }) => value)]}
        />
      )}
    </>
  );
}

function TableTitle({ title }: { title: ReactNode }) {
  return (
    <Box
      backgroundColor="tableBackgroundNeutralDark"
      borderColor="cardBorderNeutralBase"
      borderStyle="solid"
      borderWidth="1px 0 1px 0"
      color="textNeutralLight"
      fontSize="md"
      fontWeight="medium"
      padding={4}
      width="100%"
    >
      {title}
    </Box>
  );
}
